import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import dataComponent from '../hoc/dataComponent';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';

import * as Shapes from '../shapes';

import List from '../components/util/List';

import { loadEpochs } from '../actions/epoch';
import { selectEpochs } from '../selectors/epoch';
import * as clientActions from '../actions/client';

import styles from './Epochs.css';
import CapacitorRipple from '../components/capacitor/Ripple';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  metaTitle: {
    id: 'periods.meta.title',
    defaultMessage: 'Periods',
  },
  metaDescription: {
    id: 'periods.meta.description',
    defaultMessage:
      'Quickly find and play classical music from our curated repertoire, including recordings from classical masters and contemporary artists. Browse by composer, performer, instrument, genre or epoch.',
  },
});

class Epochs extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(Shapes.Category).isRequired,
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
        description: intl.formatMessage(messages.metaDescription),
        canonicalRoute: '/periods',
      })
    );
  }

  renderEpoch = item => {
    return (
      <li key={item.id}>
        <Link to={`/periods/${item.id}`}>
          <CapacitorRipple />
          {item.title}
        </Link>
      </li>
    );
  };

  render() {
    const { items } = this.props;
    return (
      <div className="u-page-container periods">
        <h1 className={`${styles.heading} fz--beta`}>
          <FormattedMessage id="periods.title" defaultMessage="Periods" />
        </h1>
        <List items={items} renderItem={this.renderEpoch} />
      </div>
    );
  }
}

function fetchData(store) {
  return store.dispatch(loadEpochs());
}

function mapStateToProps(state) {
  return {
    items: selectEpochs(state),
  };
}

export default compose(dataComponent(fetchData), connect(mapStateToProps))(Epochs);
